<template>
  <div>
    <v-container class="global-margin">
      <v-breadcrumbs :items="breadcrumbs" class="breadcrumbs pl-0" large></v-breadcrumbs>
      <v-row align="center" justify="center">
        <v-col cols="12" md="8">
          <v-col class="text-center">
            <img width="50%" :src="require('@/assets/img/edulab.svg')" />
          </v-col>
          <!--
          <v-col class="text-center">
            <Countdown deadline="August 24, 2020, 10:00" lang="hr"></Countdown>
          </v-col>
          -->

          <h2
            class="headline pt-5 pb-3 text-center"
          >Edukacija nastavnika za korištenje informacijskih tehnologija</h2>
          <p
            class="pt-3"
          >Digitalnu transformaciju obrazovanja u osnovnim i srednjim školama u županijama koje nastavni plan i program izvode na hrvatskom jeziku provodi Centar za informacijske tehnologije (SUMIT) Sveučilišta u Mostaru.</p>

          <p>Upoznati ćete se s pojmovima:</p>
          <ul class="pb-4">
            <li>Elektroničkog identitet učenika, nastavnika i profesora (AAI)</li>
            <li>Digitalne matične knjiga (eMatica)</li>
            <li>Digitalne razredne knjiga (eDnevnik)</li>
          </ul>


          <h2 class="headline pt-5 pb-3">Raspored</h2>
          <p>Tečaj će se održavati svakim danom u periodu od 24.08. - 28.08.2020.godine i to u terminu u 12:00h.</p>

          <v-col class="text-center">
            <img width="50%" :src="require('@/assets/img/skolarac-plava.svg')" />
          </v-col>
        </v-col>



        <!--
        <v-col cols="12" class="flex-left flex-column pt-6">
          <p
            ref="nav-text"
            class="mb-1 text-center w-100 overline"
          >TRENUTNI BROJ PRIJAVLJENIH NA TEČAJ</p>
          <p class="blue-text title bold w-100 text-center">{{num}}</p>
        </v-col>
        -->

        <v-col cols="12" md="8" v-for="(item, i) in upute" :key="i">
          <v-card flat :href="item.link">
            <v-row>
              <v-col cols="10">
                <v-card-title style="color: #084776">{{item.title}}</v-card-title>
                <v-card-subtitle>{{item.text}}</v-card-subtitle>
              </v-col>
              <v-col cols="2">
                <v-card-text>
                  <v-icon class="mt-3" color="#084776">fas fa-chevron-right</v-icon>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-col>

        <v-col cols="12" class="text-center" style="margin-top: 50px;">
          <img width="66%" :src="require('@/assets/img/edukacija-info.jpg')" />
          <a href="https://skole.sum.ba/admin/radionica#/" target="blank" class="text-center">
            <img width="65%" :src="require('@/assets/img/edukacija-nastavnika.jpg')" />
          </a>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Countdown from "vuejs-countdown";
export default {
  components: { Countdown },
  mounted() {
    this.getNumberOfApplicants();
  },
  methods: {
    getNumberOfApplicants() {
      axios
        .get("https://skole.sum.ba/admin/api/radionica/prijave/2020-08-24")
        .then(response => {
          this.num = response.data;
        //   console.log(this.num);
        })
        .catch(error => console.log(error.message));
    }
  },
  data() {
    return {
      num: null,
      upute: [
        {
          title: "Prijavi se na Školarac",
          text: "Kliknite ovdje za prijavu na sustav Školarac",
          link: "https://skolarac.sum.ba/"
        },
        {
          title: "Upute za prijavu na Školarac",
          text: "Kliknite ovdje za preuzimanje uputa (.pdf)",
          link: "https://skole.sum.ba/admin/dokumenti/upute_za_prijavu_na_skolarac.pdf"
        },
        {
          title: "Program tečaja",
          text: "Kliknite ovdje za preuzimanje programa tečaja (.pdf)",
          link:
            "https://skole.sum.ba/admin/dokumenti/Edukacija_nastavnika_za_kori%C5%A1tenje_informacijskih_tehnologija.pdf"
        },


      ],

      breadcrumbs: [
        {
          text: "Naslovnica",
          disabled: false,
          to: "/"
        },
        {
          text: "EduLab",
          disabled: true
        }
      ]
    };
  }
};
</script>

<style scoped>
.vuejs-countdown {
  color: #084776;
}
</style>
